const Login = () => import('@/views/Login/Login.vue');
const ForgotPassword = () => import('@/views/Login/ForgotPassword');
const ResetPassword = () => import('@/views/Login/ResetPassword');
const MemberAuthentication = () => import('@/views/Login/MemberAuthentication');

export default [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
  },
  {
    path: '/member-authentication',
    name: 'member-authentication',
    component: MemberAuthentication,
  },
];
